import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=a3d6319c&scoped=true&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d6319c",
  null
  
)

export default component.exports